import { MPSelect } from '@components';
import { Form } from 'antd';

export default function Tags() {
    return (
        <>
            <Form.Item
                name={'tags'}
                label={'Tags'}
            >
                <MPSelect open={false} mode="tags" />
            </Form.Item>
        </>
    );
}
